<script>
export default {
  mounted () {
  },
  computed: {
    urlDomain () {
      if (localStorage.getItem('headerDomain')) {
        return localStorage.getItem('headerDomain')
      } else {
        return null
      }
    },
    urlOrganization () {
      if (this.$store.getters.getUrlInfo) {
        return this.$store.getters.getUrlInfo.organizacion
      } else {
        return null
      }
    },
    urlBrand () {
      if (this.$store.getters.getUrlInfo) {
        return this.$store.getters.getUrlInfo.marca
      } else {
        return null
      }
    },
    stylePath () {
      return this.$store.getters.getStylePath
    },
    existsUrlDomain () {
      return this.urlDomain !== undefined && this.urlDomain !== null && this.urlDomain !== ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/mixins/globals/mx-domain.vue